import axios from 'axios'
import { AbstractService } from "./abstract.service";
export class SettingService extends AbstractService {
  static get entity_payon() {
      return '/n360/mcmnt/api/merchant'
  }

  static get entityStore() {
    return "nsh/store/api/store"
  }

  static get entityStore_2() {
    return "nsh/store/api/store"
  }

  static get entityReturnSO() {
    return 'nsh/main/api/merchant'
}

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  // CONNECT PAYON
  // Api check infor merchant with Payon
  static async getMerchantPayonInfor(params) {
      try {
          const response = await this.callApi().post(
              `${this.entity_payon}/get-by-merchantId`,
              params
          )
          return this.responseWrapper(response, response.data.data)
      } catch (error) {
          const message = "Error";
          throw this.errorWrapper(error, message);
      }
  }

  static async getMerchantPayonInforV2(type) {
    try {
        const response = await this.callApi().get(`/n360/inte/api/mng-inte-app/detail-link?partnerType=${type}`)
        return this.responseWrapper(response, response.data)
    } catch (error) {
        const message = "Error";
        throw this.errorWrapper(error, message);
    }
  }

  // Api synchronized merchant with Payon ( use when api connectMerchantWithPayon return fail )
  static async syncMerChantWithPayon() {
      try {
          const response = await this.callApi().post(`${this.entity_payon}/get`);
          return this.responseWrapper(response, response.data.data);
      } catch (error) {
          const message = "Error";
          throw this.errorWrapper(error, message);
      }
  }

  // Api connect merchant with Payon
  static async connectMerchantWithPayon(params) {
      try {
          const response = await this.callApi().post(`/n360/inte/api/mng-inte-app/link-app`, params);
          return this.responseWrapper(response, response.data.data);
      } catch (error) {
          const message = "Error";
          throw this.errorWrapper(error, message);
      }
  }

  // check method pay
  static async checkPayMethod(params) {
    try {
      const response = await this.callApi().get(
        `${this.entityStore}/getPayMethodAvailableByMerchantId/${params}`
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // update store
  static async updateStore(params) {
    try {
      const response = await this.callApi().put(
        `${this.entityStore}`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // creat store
  static async createStore(params) {
    try {
      const response = await this.callApi().post(
        `${this.entityStore}`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // get infor Merchant
  static async getInforMerchant(params) {
    try {
      const response = await this.callApi().get(
        `${this.entityStore}/getByCoMerchantIdAndCoLocationId?coMerchantId=${params.merchantId}&coLocationId=${params.locationId}`)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getMerchantAliasName(params) {
    try {
      const response = await axios.get(
        `${this.URL_GATEWAY}/${this.entityStore}/getByMerchantAliasName/${params}`,
        {
          headers: {
          }
        }
      )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }
  // Get data Merchant
  static async getDataMerchant() {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/n360/mcmnt/api/merchant/get`,
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getMcInfo(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/n360/mcmnt/api/merchant/get`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

    // Update data Merchant
    static async updateMerchant(params) {
      try {
        const response = await this.callApi().post(
          `${this.URL_GATEWAY}/n360/mcmnt/api/merchant/update-merchant`, params
        );
        return this.responseWrapper(response, response.data.data);
      } catch (error) {
        const message = "Error";
        throw this.errorWrapper(error, message);
      }
    }

    static async updateNagativeInventory(params) {
      try {
        const response = await this.callApi().post(
          `${this.URL_GATEWAY}/n360/mcmnt/api/merchant/setup-negative-inv`, params
        );
        return this.responseWrapper(response, response.data.data);
      } catch (error) {
        const message = "Error";
        throw this.errorWrapper(error, message);
      }
    }

    static async updatePushPayment(params) {
      try {
        const response = await this.callApi().post(
          `${this.URL_GATEWAY}/n360/mcmnt/api/merchant/setup-push-payment-mpos`, params
        );
        return response.data
      } catch (error) {
        const message = "Error";
        throw this.errorWrapper(error, message);
      }
    }

    // update setup item config
    static async updateItemConfig(params) {
      try {
        const response = await this.callApi().post(
          `${this.URL_GATEWAY}/n360/mcmnt/api/merchant/setup-item-mgmt-method`, params
        );
        return this.responseWrapper(response, response.data.data);
      } catch (error) {
        const message = "Error";
        throw this.errorWrapper(error, message);
      }
    }
  static async enableInventory(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/n360/mcmnt/api/merchant/enable-inventory`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // convert data NS1 => NS2
  static async convertFile(data) {
    try {
      const response = await this.callApi(false).post(
        `nsh/data-migration/excel-to-excel?type=${data.type}`,
        data.file,
        {
          headers: {
            'responseType': 'blob'
          }
        }
      );

      return response
    } catch (error) {
      console.log(error);
    }
  }

  static async convertDataNs1ToNs2() {
    try {
      const response = await this.callApi().get(`nsh/migrate/api/migration/start-sync`)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async checkSyncStatusNs1LinkNs2(){
    try {
      const response = await this.callApi().get(`nsh/migrate/api/migration/check-sync-status`)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async checkLinkedStatusNs1LinkNs2(){
    try {
      const response = await this.callApi().get(`nsh/migrate/api/migration/check-linked-status`)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async mainApiMerchant() {
    try {
      const response = await this.callApi().get(`${this.entityReturnSO}`);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async mainApiMerchantPut(params) {
    try {
      const response = await this.callApi().put( `${this.entityReturnSO}`, params);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }

  }
}
